import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { SpotlightDetail } from '../types/spotlights';

interface SpotlightCardProps {
  spotlight: SpotlightDetail;
}

export const SpotlightCard = ({ spotlight }: SpotlightCardProps) => {
  const formattedPrice = spotlight.SpotlightPrice.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow">
      <div className="aspect-square relative bg-muted">
        {spotlight.SpotlightImage?.url ? (
          <img
            src={spotlight.SpotlightImage.url}
            alt={spotlight.SpotlightImage.alternativeText || spotlight.SpotlightInformation}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="text-muted-foreground text-sm">No image</span>
          </div>
        )}
        <Badge className="absolute top-2 right-2 bg-amber-500 hover:bg-amber-600">
          Featured
        </Badge>
      </div>
      <CardContent className="p-4">
        <div className="text-2xl font-bold text-primary mb-2">{formattedPrice}</div>
        <p className="text-sm text-muted-foreground line-clamp-2">
          {spotlight.SpotlightInformation}
        </p>
      </CardContent>
    </Card>
  );
};
